import H2 from "@/atoms/text/H2";
import InputField from "@/molecules/InputField";
import TextField from "@/molecules/TextField";
import Button from "@/atoms/Button";
import Para from "@/atoms/text/Para";
import { SuccessIcon } from "@/atoms/Icons";
import H3 from "@/atoms/text/H3";
import { BRAND_ID } from "@/utils/constants";
import { useEffect, useState, useRef } from "react";
import { makeIntegrationRequest } from "@/utils/fetchHelper";
import { highlightInvalidFields, onFocus } from "@/utils/commonUtil";

const IntegrationForm = () => {
  const [integrationInfo, setIntegrationInfo] = useState({});
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [isFromSubmitted, setIsFromSubmitted] = useState(false);
  const textAreaElem = useRef(null);

  const successCallback = (response) => {
    setIsButtonLoading(false);
    setIsFromSubmitted(true);
  };
  const failureCallback = (response) => {
    setIsButtonLoading(false);
  };

  function onBlur(event, info) {
    setIntegrationInfo((prevIntegrationInfo) => ({
      ...prevIntegrationInfo,
      [info.emittedBy]: info,
    }));
    const integrationReqElement = textAreaElem.current;
    if (integrationReqElement.classList.contains("error")) {
      integrationReqElement.parentElement.classList.add("error");
    } else {
      integrationReqElement.parentElement.classList.remove("error");
    }
  }

  function isIntegrationInfoValid(integrationInfo) {
    return (
      integrationInfo &&
      Object.keys(integrationInfo).length &&
      Object.values(integrationInfo).every((value) => value.valid)
    );
  }

  const formSubmitHandler = (e) => {
    e.preventDefault();
    const requestPayload = {
      brandId: BRAND_ID,
      name: integrationInfo.name.value,
      email: integrationInfo.email.value,
      integrationRequest: integrationInfo.integrationRequest.value,
    };
    if (isIntegrationInfoValid(integrationInfo)) {
      setIsButtonLoading(true);
      makeIntegrationRequest({
        payload: requestPayload,
        successCallback,
        failureCallback,
      });
    } else if (integrationInfo && Object.keys(integrationInfo).length) {
      highlightInvalidFields(integrationInfo);
    }
  };

  function initialiseIntegrationFold() {
    const integrationInfoTemp =
      window.InputValidator &&
      window.InputValidator.fields.initialize({
        fields: {
          integrationRequest: {
            selector: "#description-field",
            type: "text",
            errorClassName: "error",
          },
          email: {
            selector: "#email-field",
            type: "email",
            errorClassName: "error",
          },
          name: {
            selector: "#app-name-field",
            type: "text",
            errorClassName: "error",
          },
        },
        eventListeners: {
          blur: onBlur,
          focus: onFocus,
        },
      });
    setIntegrationInfo(integrationInfoTemp);
  }

  useEffect(() => {
    initialiseIntegrationFold();
  }, []);

  return !isFromSubmitted ? (
    <div className="modal--card bc-white">
      <H2 className="mb-7 bold" desktopSize="md">
        New integration <br />
        request<span className="dot">.</span>
      </H2>
      <div className="integration-form mb-2">
        <InputField
          label="Name of the software"
          id="app-name-field"
          name="name"
          className="mb-6"
          placeholder="Enter the software name"
        />
        <TextField
          ref={textAreaElem}
          label="Description"
          id="description-field"
          name="integrationRequest"
          className="mb-6"
          placeholder="Description"
        />
        <InputField
          label="Email address"
          id="email-field"
          name="email"
          className="mb-7"
          placeholder="Your email address"
        />
        <Button
          type="submit"
          href="#"
          size="lg"
          className={`btn--md tc-black ${isButtonLoading ? "loading" : ""}`}
          onClick={formSubmitHandler}
        >
          Submit Request
        </Button>
      </div>
      <Para color="grey" desktopSize="xs" mobileSize="xs" className="ta-left">
        We'll always keep your details secure & private. By submitting this form
        you agree to our{" "}
        <a className="text--link" href="/privacypolicy">
          privacy policy
        </a>
        .
      </Para>
    </div>
  ) : (
    <div className="modal--card bc-white w-100">
      <div className="thankyou ta-center pv-10-d pt-5 pb-6">
        <SuccessIcon className="mb-2" />
        <H3 desktopSize="lg" className="bold">
          Thank you<span className="dot">.</span>
        </H3>
        <Para desktopSize="lg" mobileSize="lg">
          Your response was submitted.
        </Para>
        <style jsx>{`
          @media (min-width: 750px) {
            .thankyou {
              min-width: 420px;
            }
          }
        `}</style>
      </div>
    </div>
  );
};

export default IntegrationForm;
